<template>
  <div class="mapPlaceHint">
    Bitte klicken Sie zum Speichern in der Karte auf die gewünsche Position.
  </div>
</template>

<script>

export default {
  name: 'MapPlaceHint'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .mapPlaceHint {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    z-index: 9999;
    padding: 0px 20px;
    line-height: 48px;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    background: rgba($color-text,0.9);
    text-align:center;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.3);
  }

</style>



// WEBPACK FOOTER //
// src/components/MapPlaceHint.vue